<div class="modal-content m-0">
  <div class="modal-header">
    <p class="modal-title">
      {{ 'kitsPage.details.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    @if (data$ | async; as data) {
      <div class="row pb-3">
        <div>
          <div class="d-flex justify-content-between align-items-end mb-1">
            <p class="caption mb-1">
              {{ 'common.titleBaseInformation' | translate }}
            </p>
            <div class="text-end col-3">
              <button
                class="icon-btn mb-1 me-2"
                [ngbTooltip]="'kitsPage.tooltips.sampleDetails' | translate"
                triggers="hover"
                placement="left"
                *appRequirePermission="'sample.access'"
                type="submit"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                [disabled]="!data.kit?.productInventoryItemIds?.length"
                (click)="openSampleDetails(data.kit?.id)"
              >
                <i class="fa-light fa-droplet fa-fw"></i>
              </button>
              <button
                class="icon-btn mb-1 me-2"
                [ngbTooltip]="'kitsPage.buttons.followUps' | translate"
                triggers="hover"
                Placement="left"
                *appRequirePermission="'followUps'"
                type="submit"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="
                  followUpsUtils.openFollowUpsListDialog(data.kit?.followUpIds)
                "
              >
                <i class="fa-light fa-square-exclamation fa-fw"></i>
              </button>
              <button
                class="icon-btn mb-1 me-2"
                [ngbTooltip]="'kitsPage.buttons.addFollowUps' | translate"
                triggers="hover"
                placement="left"
                *appRequirePermission="'followUps'"
                [class.icon-btn-sm]="!coreUtilsService.tabletMode()"
                [class.icon-btn-lg]="coreUtilsService.tabletMode()"
                (click)="addFollowUp(data.kit?.id)"
              >
                <i
                  class="fa-kit fa-light-square-exclamation-circle-plus fa-fw"
                ></i>
              </button>
            </div>
          </div>
          <hr class="mt-0" />
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.kit' | translate
              }}</label>
              <div class="col-8">
                {{ data.kit?.id }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.generated' | translate
              }}</label>
              <div class="col-8">
                {{ data.kit?.generated.timestamp | date: 'MMM dd, y HH:mm' }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.partner' | translate
              }}</label>
              <div class="col-8">
                {{ data.partner?.name ?? '/' }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.country' | translate
              }}</label>
              <div class="col-8">
                {{ data.partner?.address.country ?? '/' }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.lastStatus' | translate
              }}</label>
              <div class="col-8">
                {{ 'kitsStatuses.' + data.kit?.lastStatus | translate }}
              </div>
            </div>
            <div
              class="col-12 col-md-6 row align-items-center"
              *appRequirePermission="'kits.extendedData'"
            >
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.lastStatusChanged' | translate
              }}</label>
              <div class="col-8">
                {{ data.kit?.lastStatusChanged | date: 'MMM dd, y HH:mm' }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.expiryDate' | translate
              }}</label>
              <div class="col-8">
                {{ data.kit?.expiryDate | date: 'MMM dd, y' }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.laboratory' | translate
              }}</label>
              <div class="col-8">
                {{ data.kit?.laboratory }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.collectorType' | translate
              }}</label>
              <div class="col-8">
                {{
                  data.kit?.collector
                    | displayName: (collectorTypes$ | async) : 'id' : 'type'
                }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.kitType' | translate
              }}</label>
              <div class="col-8">
                {{ 'kitsPage.kitsForm.kitTypes.' + data.kit?.type | translate }}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.shippingProfile' | translate
              }}</label>
              <div class="col-8" data-cy="kit-details-shipping-profile">
                {{
                  'common.shippingProfileTypes.' +
                    (data.kit?.shippingProfileKey || 'default') | translate
                }}
              </div>
            </div>
          </div>
          <div class="row mb-2" *appRequirePermission="'kits.extendedData'">
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.runs' | translate
              }}</label>
              <div class="col-8">
                {{ runs() || '/' }}
              </div>
            </div>
            <div class="col-12 col-md-6 row align-items-center">
              <label class="label col-4 mb-0 text-end">{{
                'kitsPage.details.notes' | translate
              }}</label>
              <div class="col-8">
                {{ data.kit?.notes || '/' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="py-4 loading"></div>
    }
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      type="button"
      class="btn btn-clear"
      (click)="modalRef.close()"
    >
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
